import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import TextFormInput from '../../input/Text';
/**
 * @extends {React.Component<import('./types').FinalFormFieldTextBaseProps>}
 */

var Text =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Text, _React$Component);

  function Text() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Text);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Text)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.setInputRef = function (input) {
      _this.inputRef = input;
    };

    return _this;
  }

  _createClass(Text, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocusSelect) {
        var self = this;
        setTimeout(function () {
          if (self.inputRef) self.inputRef.select();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$input = _this$props.input,
          name = _this$props$input.name,
          onChange = _this$props$input.onChange,
          value = _this$props$input.value,
          restInput = _objectWithoutProperties(_this$props$input, ["name", "onChange", "value"]),
          meta = _this$props.meta,
          helperText = _this$props.helperText,
          autoFocusSelect = _this$props.autoFocusSelect,
          autoComplete = _this$props.autoComplete,
          rest = _objectWithoutProperties(_this$props, ["input", "meta", "helperText", "autoFocusSelect", "autoComplete"]);

      var hasError = meta.error && meta.touched;
      return React.createElement(TextFormInput, Object.assign({}, rest, {
        name: name,
        helperText: hasError ? meta.error : helperText,
        error: hasError,
        inputProps: _objectSpread({
          autoComplete: autoComplete
        }, restInput),
        onChange: onChange,
        value: value,
        inputRef: this.setInputRef
      }));
    }
  }]);

  return Text;
}(React.Component);

export default Text;